<div class="container p-80">
	<div class="content flex flex-col justify-center items-center text-center gap-5">
		<!-- <h2>.</h2> -->
		<mat-progress-spinner
			class="example-margin"
			[color]="color"
			[mode]="mode"
			[value]="value"
		>
		</mat-progress-spinner>

		<h3 class="pt-5">Cargando...</h3>
	</div>
</div>
